import { defineComponent, PropType } from "vue";
import ImageFallback from "./imageFallback.js";
import { getMemberAvatar, getMemberDisplayName } from "../utils.js";
import { useCachedMember } from "../utils/memberCache.js";

export default defineComponent({
    props: {
        id: {
            type: String,
            required: true,
        },

        fallbackLabel: {
            type: String as PropType<string | null>,
            default: null,
        },
    },

    setup(props) {
        const member = useCachedMember(props.id);

        return () => {
            const loadedMember = member.value;
            const label = loadedMember
                ? getMemberDisplayName(loadedMember)
                : props.fallbackLabel || props.id;

            return (
                <router-link to={`/users/${props.id}`} class="markdown-member-mention">
                    {loadedMember && (
                        <ImageFallback
                            class="markdown-member-mention__avatar"
                            src={getMemberAvatar(loadedMember)}
                            default="https://cdn.discordapp.com/embed/avatars/0.png"
                            alt={label}
                        />
                    )}
                    <span>@{label}</span>
                </router-link>
            );
        };
    },
});
